import { createContext } from 'react';

const Context = createContext<string | null>(null);

export default Context;
